(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection-custom"] && !Shopify.designMode) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["nutrient-calculator"] && !Shopify.designMode) return;
  try {
    
var _sourceEC = 0.2;
var _targetEC = 1.4;
var _sourceL = 100;
var _targetL = 0;
var _cropType = "P";

var sourceECInput = document.getElementById('sourceEC');
var targetECInput = document.getElementById('targetEC');
var tankMixLitersInput = document.getElementById('tankMixLiters');
var cropTypeSelect = document.getElementById('cropType');

sourceECInput.addEventListener('change', calculate);
targetECInput.addEventListener('change', calculate);
tankMixLitersInput.addEventListener('change', calculate);
cropTypeSelect.addEventListener('change', calculate);

const FACTORS = {
  Hygrotech: {
    LG: { h: 0.050, c: 0.0325, k: 0 },
    MG: { h: 0.012, c: 0.008125, k: 0 },
    C:  { h: 0.050, c: 0.050,  k: 0 },
    P:  { h: 0.050, c: 0.050,  k: 0 },
    "T0-1": { h: 0.056, c: 0.044, k: 0 },
    "T1-2": { h: 0.060, c: 0.040, k: 0 },
    "T2-3": { h: 0.052, c: 0.035, k: 0.013 }
  },
  Hydrofood: {}
};
// FACTORS.Hydrofood = JSON.parse(JSON.stringify(FACTORS.Hygrotech)); // duplicate for now
FACTORS.Hydrofood = 
  {
  "LG":  { "h": 0.056, "c": 0.049, "k": 0.000 },
  "MG":  { "h": 0.058, "c": 0.040, "k": 0.000 },
  "C":   { "h": 0.057, "c": 0.045, "k": 0.009 },
  "P":   { "h": 0.057, "c": 0.045, "k": 0.002 },
  "T0-1":{ "h": 0.037, "c": 0.052, "k": 0.013 },
  "T1-2":{ "h": 0.045, "c": 0.047, "k": 0.012 },
  "T2-3":{ "h": 0.047, "c": 0.044, "k": 0.013 }
};

// You are an agronomist and hydroponic chemist.

// Goal  
// Generate per-mS factors {h, c, k} for 1 000 L stock solution so growers can dose with:
//     grams_to_dose = (EC_target − EC_source) × factor × 1 000
// (The app inserts growers’ EC values later.)

// Inputs  
// 1. Hydrofood guaranteed analysis, g kg⁻¹ (dry weight):  
//    N 65, P 45, K 240, Mg 30, S 60, Fe 1.68, Mn 0.40, Zn 0.20, Cu 0.03, Mo 0.05, B 0.20. (Ca 0)

// 2. Supplemental salts  
//    • Calcium nitrate (CN): 15.5 % N, 19.6 % Ca  
//    • Potassium nitrate (KN): 13 % N, 46 % K₂O ( = 38.3 % K elemental)

// 3. Crop codes, reference EC, and elemental targets  

// | Code | EC_ref | N | P | K | Ca | Mg |
// |------|-------|---|---|---|----|----|
// | LG   | 1.4 | 160 | 40 | 200 | 150 | 40 |
// | MG   | 0.8 |  80 | 20 | 120 |  60 | 20 |
// | C,P  | 2.0 | 180 | 45 | 250 | 160 | 40 |
// | T0-1 | 1.8 | 130 | 30 | 250 | 180 | 45 |
// | T1-2 | 2.4 | 160 | 40 | 300 | 180 | 50 |
// | T2-3 | 2.6 | 180 | 45 | 340 | 180 | 55 |

// Assume de-ionised source water (0 ppm).

// Tasks  
// A. For each crop code, blend Hydrofood (h), calcium nitrate (c) and potassium nitrate (k) so the final solution at **EC_ref** hits the elemental ppm targets.  
//  • Keep Mg and S within ±10 % of targets.  
//  • Trace elements follow Hydrofood proportionally.  
//  • Use K₂O→K factor 0.830.  
//  • Incremental EC contribution: 1 mS cm⁻¹ ≈ 640 ppm.

// B. Convert the grams used at EC_ref to per-mS factors for 1 000 L:  
//  factor = (grams_at_EC_ref) ÷ (EC_ref) ÷ 1 000.

// C. Round each factor to three decimals.

// D. Self-check (MUST pass before you answer):  
//  1. Recalculate the final ppm profile using your factors × EC_ref × 1 000.  
//  2. Confirm EC error ≤ ±0.02 mS and every macro within its tolerance.  
//  3. If error > limits, iterate automatically until compliant.

// E. Return **only** the JSON block:

// {
//   "LG":  { "h": #.###, "c": #.###, "k": #.### },
//   "MG":  { … },
//   "C":   { … },
//   "P":   { … },
//   "T0-1":{ … },
//   "T1-2":{ … },
//   "T2-3":{ … }
// }

// Guidelines  
// • Keep the Hydrofood : CN : KN ratio identical across EC scaling so growers can simply nudge all three factors up or down to fine-tune EC later.  
// • If Mg deficit persists, note that an external MgSO₄ addition may be required (do **not** change factors).  
// • Provide no extra commentary—only the JSON block when finished.

function calculate() {
    _sourceEC = parseFloat(sourceECInput.value);
    _targetEC = parseFloat(targetECInput.value);
    _targetL = parseFloat(tankMixLitersInput.value);
    _cropType = cropTypeSelect.value;

    if (_sourceEC >= _targetEC) {
        alert("Source EC cannot be higher than the Target.");
        return;
    }

    const BRANDS = ["Hygrotech", "Hydrofood"];
    const MAX_CAP = 100; // for progress bar scaling

    BRANDS.forEach(brand => {
        const f = FACTORS[brand][_cropType] || FACTORS[brand]["P"]; // fallback
        const gH = ((_targetEC - _sourceEC) * f.h) * 10000;
        const gC = ((_targetEC - _sourceEC) * f.c) * 10000;
        const gK = ((_targetEC - _sourceEC) * f.k) * 10000;

        const H = ((gH / 1000) * _targetL).toFixed(0);
        const C = ((gC / 1000) * _targetL).toFixed(0);
        const K = ((gK / 1000) * _targetL).toFixed(0);

        const suf = (brand === "Hydrofood") ? "_hf" : "";

        document.getElementById(`txtHydroponic${suf}`).innerHTML =
            `<b><span class='bigtext'>${H}g</span></b> (${(H/1000).toFixed(2)}Kg),`;
        document.getElementById(`txtSoluCal${suf}`).innerHTML =
            `<b><span class='bigtext'>${C}g</span></b> (${(C/1000).toFixed(2)}Kg),`;
        document.getElementById(`txtUltrasol${suf}`).innerHTML =
            `<b><span class='bigtext'>${K}g</span></b> (${(K/1000).toFixed(2)}Kg).`;

        const bars = document.querySelectorAll(brand === "Hydrofood"
                           ? '.progress-bar.hf' : '.progress-bar:not(.hf)');
        [H,C,K].forEach((val, i) => {
            const pct = Math.min((val / MAX_CAP) * 100, 100);
            bars[i].style.width = pct ? pct + '%' : '0%';
            bars[i].style.background = pct ? ['green','orange','gray'][i] : 'transparent';
        });
    });
}
  
  
// FACTORS.Hydrofood = JSON.parse(JSON.stringify(FACTORS.Hygrotech));
//     var _sourceEC = 0.2;
//   var _targetEC = 1.4;
//   var _sourceL = 100;
//   var _targetL = 0;
//   var _cropType = "P";



//   // Assuming these are basic input elements now
//   var sourceECInput = document.getElementById('sourceEC');
//   var targetECInput = document.getElementById('targetEC');
//   var tankMixLitersInput = document.getElementById('tankMixLiters');
//   var cropTypeSelect = document.getElementById('cropType');

//   sourceECInput.addEventListener('change', calculate);
//   targetECInput.addEventListener('change', calculate);
//   tankMixLitersInput.addEventListener('change', calculate);
//   cropTypeSelect.addEventListener('change', calculate);

//   function calculate() {
//       _sourceEC = parseFloat(sourceECInput.value);
//       _targetEC = parseFloat(targetECInput.value);
//       _targetL = parseFloat(tankMixLitersInput.value);
//       _cropType = cropTypeSelect.value;

//       if (_sourceEC >= _targetEC) {
//           alert("Source EC cannot be higher than the Target.");
//           return;
//       }

//       var _hygroponicFactor = 0.050;
//       var _calciumNitrateFactor = 0.050;
//       var _potassiumNitrateFactor = 0;

//       var _hygroponicGrams = 0;
//       var _calciumNitrateGrams = 0;
//       var _potassiumNitrateGrams = 0;

//       var _hygroponicKg = 0;
//       var _calciumNitrateKg = 0;
//       var _potassiumNitrateKg = 0;

//       switch (_cropType) {
//           case "LG":
//               _hygroponicFactor = 0.050;
//               _calciumNitrateFactor = 0.0325;
//               _potassiumNitrateFactor = 0;
//               break;
//           case "MG":
//               _hygroponicFactor = 0.012;
//               _calciumNitrateFactor = 0.008125;
//               _potassiumNitrateFactor = 0;
//               break;
//           case "C":
//               _hygroponicFactor = 0.050;
//               _calciumNitrateFactor = 0.050;
//               _potassiumNitrateFactor = 0;
//               break;
//           case "P":
//               _hygroponicFactor = 0.050;
//               _calciumNitrateFactor = 0.050;
//               _potassiumNitrateFactor = 0;
//               break;
//           case "T0-1":
//               _hygroponicFactor = 0.056;
//               _calciumNitrateFactor = 0.044;
//               _potassiumNitrateFactor = 0;
//               break;
//           case "T1-2":
//               _hygroponicFactor = 0.060;
//               _calciumNitrateFactor = 0.040;
//               _potassiumNitrateFactor = 0;
//               break;
//           case "T2-3":
//               _hygroponicFactor = 0.052;
//               _calciumNitrateFactor = 0.035;
//               _potassiumNitrateFactor = 0.013;
//               break;
//           default:
//               _hygroponicFactor = 0.050;
//               _calciumNitrateFactor = 0.050;
//               _potassiumNitrateFactor = 0;

//       }

//       _hygroponicGrams = ((_targetEC * _hygroponicFactor) - (_sourceEC * _hygroponicFactor)) * 10000;
//       _calciumNitrateGrams = ((_targetEC * _calciumNitrateFactor) - (_sourceEC * _calciumNitrateFactor)) * 10000;
//       _potassiumNitrateGrams = ((_targetEC * _potassiumNitrateFactor) - (_sourceEC * _potassiumNitrateFactor)) * 10000;

//       _hygroponicGrams = (_hygroponicGrams / 1000) * _targetL;
//       _calciumNitrateGrams = (_calciumNitrateGrams / 1000) * _targetL;
//       _potassiumNitrateGrams = (_potassiumNitrateGrams / 1000) * _targetL;

//       _hygroponicGrams = _hygroponicGrams.toFixed(0);
//       _calciumNitrateGrams = _calciumNitrateGrams.toFixed(0);
//       _potassiumNitrateGrams = _potassiumNitrateGrams.toFixed(0);

//       _hygroponicKg = (_hygroponicGrams / 1000).toFixed(2);
//       _calciumNitrateKg = (_calciumNitrateGrams / 1000).toFixed(2);
//       _potassiumNitrateKg = (_potassiumNitrateGrams / 1000).toFixed(2);


//       console.log(_hygroponicGrams);
//       console.log(_calciumNitrateGrams);

     
// // Update text
// document.getElementById("txtHydroponic").innerHTML = `<b><span class='bigtext'>${_hygroponicGrams}g</span></b> (${_hygroponicKg}Kg),`;
// document.getElementById("txtSoluCal").innerHTML = `<b><span class='bigtext'>${_calciumNitrateGrams}g</span></b> (${_calciumNitrateKg}Kg),`;
// document.getElementById("txtUltrasol").innerHTML = `<b><span class='bigtext'>${_potassiumNitrateGrams}g</span></b> (${_potassiumNitrateKg}Kg).`;

// // Dynamically style progress bars
// const progressBars = [
//   { id: "txtHydroponic", selector: ".progress-bar", index: 0, value: _hygroponicGrams, color: "green" },
//   { id: "txtSoluCal", selector: ".progress-bar", index: 1, value: _calciumNitrateGrams, color: "orange" },
//   { id: "txtUltrasol", selector: ".progress-bar", index: 2, value: _potassiumNitrateGrams, color: "gray" },
// ];

// const MAX_CAPACITY = 100; // Max liters at which progress bar is full (100%)

// progressBars.forEach(bar => {
//   const el = document.querySelectorAll(bar.selector)[bar.index];
//   const value = parseInt(bar.value);

//   // Scale percent relative to 800L max
//   const percent = Math.min((value / MAX_CAPACITY) * 100, 100);

//   el.style.width = percent > 0 ? `${percent}%` : `0%`;
//   el.style.background = percent > 0 ? bar.color : "transparent";
// });

//   }

  } catch(e) { console.error(e); }
})();
})();
